export const api = {
  device: {
    getGateTree: '/bms/device/queryDeviceTree.json', //出入口授权-车辆通行权限，查询车辆闸机设备树
    departmentTree: '/vas/department/queryDepartmentTree.json', //部门树
  },
  vehicle: {
    getVehicleList: '/vas/vehicle/queryVehicleListApi.json',//获取车辆列表
    getAuthorityList: '/bms/vehiclebarrier/queryVehicleBarrierAuthorityList.json', // 获取车辆授权列表  
    updateAuthority: '/bms/vehiclebarrier/updateVehicleBarrierAuthority.json', // 修改车辆授权
    addCarAuthority: '/bms/vehiclebarrier/addVehicleBarrierAuthority.json',//新增车辆授权
    deleteCarAuthority: '/bms/vehiclebarrier/deleteVehicleBarrierAuthority.json',//删除车辆授权
    syncAuthorityList: '/bms/vehiclebarrier/syncVehicleBarrierVehicle.json',//车辆授权页面同步
    getRecordList: '/bms/vehiclebarrier/queryVehicleBarrierAuthorityRecordListApi.json',//详情页面授权信息列表接口
    exportAuthorityList: '/bms/vehiclebarrier/exportVehicleBarrierAuthorityList.json',//导出车辆授权列表
    queryVisitorVehicleType: ' /vas/vehicle/queryVisitorVehicleTypeList.json',//查询访客车辆分类组
  }
}